export default "__VITE_ASSET__6m1ImYS3__"